<template>
  <div class="hjnavigation fixedPos d-flex flex-column flex-md-row bg-white border-bottom">

	<div class="container-fluid header-container">
		<div class="row no-gutters pt-2 pb-2 header-navtop mobile-hidden">
			<div class="col-2 text-left ml-2 ml-lg-5">
				<template v-for="(group, index) in topurl">
					<template v-for="(link, subindex) in group">
						<template v-if="!Array.isArray(link)" >	
							<a :href="link['cta'].value" class="shangrila" target="_blank">{{link['title'].value}}</a>
						</template>
					</template>		
				</template>					
			</div>
			<div class="col-9 ml-auto text-right mr-2 mr-lg-4 mr-xl-5">
			
				
				<!--<a href=""><img :src="personIcon" class="signin-icon mr-2"/>Sign In</a> 
				&nbsp;|&nbsp; 
				<a href="https://www.shangri-la.com/en/corporate/golden-circle/joingc/" target="_blank">Join Now</a> 
				&nbsp;|&nbsp; 
				<a href="">Find Reservations</a> &nbsp;|&nbsp; -->
				
				<template v-for="(group, index) in toplinks">
						<template v-for="(link, subindex) in group">								
							<template v-if="Array.isArray(link)" >										
								<template v-if="link.length > 0" >
									<template v-if="link[0]['image'] !=null">
											<img :src="link[0]['image']['src']" :class="'mr-2 ' + link[0]['imagetype'].value"/>
									</template>	
									<template v-if="link.length > 0 && link[0]['islanguageswitcher'] && link[0]['islanguageswitcher'].value && link[0]['islanguageswitcher'].value == '1'" >
										<select :class="'languageswitcher ' + link[0]['cssclass'].value">
											<template v-for="(subgroup, subsubindex) in link">
												<option data-url="#" :value="subgroup['value'].value">
													{{subgroup['title'].value}}
												</option>											
											</template>
											</select>&nbsp;|&nbsp; 	
									</template>
									<template v-else>
										<div class="dropdown">
										<!-- <button class="btn btn-secondary dropdown-toggle" type="button" id="currencyDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button> -->
										<button class="btn btn-secondary dropdown-toggle" type="button" id="currencyDropdown" ></button>
										<ul class="dropdown-menu" aria-labelledby="currencyDropdown">
											<li>
												<div class="row no-gutters" style="width:888px">
													<template v-for="(subgroup, subsubindex) in link">
														<div class="dropdown-item col-md-4" :data-url="[subgroup['cta'].value != null?subgroup['cta'].value:'']" :data-value="subgroup['title'].value">
															<b>{{subgroup['title'].value}}</b> {{subgroup['description'].value}}
															<label class="container">
																<input type="checkbox" class="currency-checkbox">
																<span class="checkmark"></span>
															</label>
														</div>
													</template>
												</div>
											</li>
										</ul>
										</div>
										<!-- <select :class="link[0]['cssclass'].value">
											<template v-for="(subgroup, subsubindex) in link">
												<option :data-url="[subgroup['cta'].value != null?subgroup['cta'].value:'']" :value="subgroup['title'].value">
													{{subgroup['title'].value}}
												</option>
											</template>
										</select> -->
										&nbsp;|&nbsp; 	
									</template>
								</template>
								
							</template>
							<template v-else>
								<template v-if="link['isgcsignin'] && link['isgcsignin'].value && link['isgcsignin'].value == '1'" >
									
									<a :href="getLoginHref" class="gcsignin" :data-gcsignin="getDictionaryPhrase('GCSignIn')" :data-gcsignout="getDictionaryPhrase('GCSignOut')" target="_blank">
									<template v-if="link['image'] !=null">
											<img :src="link['image']['src']" :class="'mr-2 ' + link['imagetype'].value"/>
									</template>
									<span class="gcsignintext">{{link['title'].value}}</span>
									</a> 
								</template>
								<template v-else-if="link['islanguageswitcher'] && link['islanguageswitcher'].value && link['islanguageswitcher'].value == '1'" >
									
									<a href="javascript:;" class="languageswitcher" :data-language="link['value'].value" target="_blank">
									<template v-if="link['image'] !=null">
											<img :src="link['image']['src']" :class="'mr-2 ' + link['imagetype'].value"/>
									</template>
									{{link['title'].value}}
									</a> 
								</template>
								<template v-else>
									<a :href="link['cta'].value" target="_blank">
									<template v-if="link['image'] !=null">
											<img :src="link['image']['src']" :class="'mr-2 ' + link['imagetype'].value"/>
									</template>
									{{link['title'].value}}
									</a> 
								</template>
								&nbsp;|&nbsp; 			
							</template>
						</template>
					</template>
				<!--<a href=""><img :src="globeIcon" class="globe-icon mr-2"/>English</a> 
				&nbsp;|&nbsp; -->
				<!--<select class="currencyselect">
				<option value="HKD">HKD</option>
				<option value="GBP">GBP</option>
				<option value="CNY">CNY</option>
				</select>
				&nbsp;|&nbsp;--> 
				<a href="javascript:;" class="js-header-mobile"><img :src="mobileIcon" class="mobile-icon ml-2"/></a>
				<div class="app-layer" style="display:none"><div class="app-layer-wrap"><div class="content-wrap"><div><div class="title title-regular">{{getDictionaryPhrase('MobileIconTitle')}}</div><div class="text text-regular">{{getDictionaryPhrase('MobileIconText')}}</div></div><a class="learn-more" :href="getDictionaryPhrase('MobileIconLink')" target="_hc|JIOcjIMeLYo6otGaditoox3t" rel="noopener">{{getDictionaryPhrase('MobileIconButtonText')}}</a></div><div class="img-wrap"><div class="qr-code"><div class="qr-code-img"></div></div><div class="shop-container"><a class="apple-icon" :href="getDictionaryPhrase('MobileIconAppStore')" target="_hc|JIOcjIMeLYo6otGaditoox3t" rel="noopener"></a><a class="google-icon" :href="getDictionaryPhrase('MobileIconPlayStore')" target="_hc|JIOcjIMeLYo6otGaditoox3t" rel="noopener"></a></div></div></div></div>
				
			</div>
		</div>
		<div class="row no-gutters header-nav">
			<div class="col-12">
				<nav class="navbar align-items-end">
				<template v-if="data_header">
					<template v-if="data_header['hidelogo']">
					<template v-if="data_header['hidelogo'].value != '1'">
							<div class="col-1 desktop-hidden">
							<a href="/hotels/jen" class="text-dark">
							<!--<router-link to="/hotels/jen" class="text-dark">-->
							<img :src="logoImg" alt="HotelJen" class="hj-logo"/>				
							</router-link>
						</div>
					</template>
					</template>
				</template>
					<!--<div class="col-1 desktop-hidden"><a href=""><img src="images/logo2.png" class="hj-logo"/></a></div>-->
				<template v-if="data_header">
					<template v-if="data_header['hidelogo']">
					<template v-if="data_header['hidelogo'].value != '1'">
							<div class="col-1 mobile-hidden">
							<!--<router-link to="/hotels/jen" class="text-dark">
							<img :src="logoImg" alt="HotelJen" class="hj-logo"/>				
							</router-link>-->
							<!--<a :href='homelink' class="hj-logo-link">-->
							<a href="/hotels/jen" class="hj-logo-link">
							<img :src="logoImg" alt="HotelJen" class="hj-logo"/>	
							</a>	
						</div>
					</template>
					</template>
				</template>
					<!--<div class="col-1 mobile-hidden"><a href="">
						<img src="images/jenlogo.png" class="hj-logo"/> 

					</a></div>-->
					<!-- <div class="col-1 text-center desktop-hidden"> <h3>beijing</h3> </div> -->
					<!-- <div class="col-1 space-h mobile-hidden">&nbsp;</div> -->
					<ul class="navbar-nav">
						<template v-for="(group, index) in links">
							<template v-for="(link, subindex) in group">								
										<template v-if="Array.isArray(link)" >
											<template v-if="link.length > 0" >
												<template v-for="(subgroup, subsubindex) in link">
													<li :class="link['liclass'] + ' nav-item mobile-hidden'"> <a :class="'nav-link ' + [subgroup['isanchor'].value == 1?'anchorlink':'']" :href="subgroup['cta'].value" :data-anchorlink="[subgroup['isanchor'].value == 1?subgroup['anchoralias'].value:'']" :data-urlexcluderegex="subgroup['urlexcluderegex'].value">{{subgroup['title'].value}}</a></li>
													<!-- <div :class="link['liclass'] + ' col-1 mobile-hidden'"><a :href="subgroup['cta'].value" >{{subgroup['title'].value}}</a></div> -->
												</template>
											</template>
										</template>
										<template v-else>
											<li :class="link['liclass'] + ' nav-item mobile-hidden'"> <a :class="'nav-link ' + [link['isanchor'].value == 1?'anchorlink':'']" :href="link['cta'].value" :data-anchorlink="[link['isanchor'].value == 1?link['anchoralias'].value:'']" :data-urlexcluderegex="link['urlexcluderegex'].value">{{link['title'].value}}</a></li>
											<!-- <div :class="link['liclass'] + ' col-1 mobile-hidden'"><a :href="link['cta'].value" >{{link['title'].value}}</a></div>	 -->
										</template>
							</template>
						</template>
						<li v-if="$jss.property()" class="nav-item mobile-hidden">
                                <a class="nav-link" href="javascript:;" id="other-hotels" class="other-hotels">{{getDictionaryPhrase('OtherHotels')}}</a>
                        </li>
						<li class="nav-item mobile-hidden book-nav-cta">
							<a class="nav-link btn btn-primary btn-jump booking-nav-cta" >{{getDictionaryPhrase('Book')}}</button>
						</li>
						<li class="nav-item desktop-hidden">
							<a href="" id="btn-hamburger"><img :src="hamburgerIcon" class="hamburger"></a>
						</li>
					</ul>
					<!-- <div class="col-1 space-h space-hr active mobile-hidden">&nbsp;</div>
					<div class="col-1 space-hr active text-right mobile-hidden"><a href="" class="btn btn-primary btn-jump" >{{getDictionaryPhrase('Book')}}</a></div>
					<div class="col-1 desktop-hidden align-self-center text-right"><a href="" id="btn-hamburger"><img :src="hamburgerIcon" class="hamburger"></a></div> -->
				</nav>
			</div>
		</div>
		
		<div class="row no-gutters justify-content-center booking-nav">
			<h-j-book />
		</div>
		
		<div class="row no-gutters desktop-hidden mobileMenu">
			<div class="hjenm-logo"> </div>
			<div class="col-12 mt-4">
				<div class="container-fluid pr-0 pl-0">
					<img :src="closeIcon" class="mobile-close-btn" />
					<template v-if="$jss.property()">
					<div style="position: absolute;top: 0;left: 50%;transform: translate(-50%,0);"><h3 class="header-property-m">beijing</h3></div>
					</template>
					<div class="row no-gutters mt-5 justify-content-center">
						<hr/>
						<div class="col-12 mt-2">  
							<!--<a data-toggle="collapse" href="#menu-destination"><h4 class="h4">{{getDictionaryPhrase('Destination')}}</h4></a>-->
							<a data-toggle="collapse" class="menu-destination-anchor" href="javascript:;"><h4 class="h4">{{getDictionaryPhrase('Destination')}}</h4></a>
							<div id="menu-destination" class="collapse">
							<template v-if="locations && locations.length > 0">
									<template v-for="(location, index) in locations">
									<ul>
									<template v-if="!(location['isdisabled'] && location['isdisabled'].value && location['isdisabled'].value == '1')">
									<template v-if="location['children'] && location['children'].length > 0">
										<template v-if="location['children'].length > 1">
											<li>
												<a :href="'#nav-block-'+location['title'].value" class="selected-destination">{{location["title"].value}}</a><div class="property-submenu">
												<a href="" class="submenu-close-btn-header"></a>
												<ul class="plist properties">
													<template v-for="(sublocation, subindex) in location['children']">
														<li class="selected-hotel-header" :data-hotel="sublocation['title']"><a :href="sublocation['cta']">{{sublocation['title']}}</a></li>
													</template>
													<!--<li class="selected-hotel-header" data-hotel="Orchard Gateway">Orchard Gateway</li>
													<li class="selected-hotel-header" data-hotel="south beach">south beach</li>
													<li class="selected-hotel-header" data-hotel="sentosa">sentosa</li>
													<li class="selected-hotel-header" data-hotel="tanglin">tanglin</li>-->
												</ul>
										</div>
											</li>
										</template>
										<template v-else>
											<template v-for="(hotelname, subindex) in location['children']">
												<template v-if="!(hotelname['isdisabled'] && hotelname['isdisabled'] == '1')">
													<li><a :href="hotelname['cta']">{{location['title'].value}}</a></li>
												</template>
												<!--<li><a href="">{{location["title"].value}}</a></li>-->
											</template>												                                           
										</template>
									</template>
									</template>
									</ul>
									</template>
							</template>
							<template v-if="locations && locations.length > 0">
									<template v-for="(location, index) in locations">
									
									<template v-if="location['children'] && location['children'].length > 0">
										<template v-if="location['children'].length > 0">
										<div :id="'nav-block-'+location['title'].value" class="destination-nav-block">
											<h3>{{location["title"].value}}</h3>
											<ul>
											<template v-for="(hotelname, subindex) in location['children']">
												<template v-if="!(hotelname['isdisabled'] && hotelname['isdisabled'] == '1')">
													<li><a href="hotelname['cta']">{{hotelname['title']}}</a></li>
												</template>
											</template>       
											</ul>
											<div class="destination-btn swiper-button-prev"></div>
										</div>		
										</template>
										
									</template>
									
									</template>
							</template>
							</div>
						</div>
					</div>
					
					<!-- Mobile Links -->
					<template v-for="(group, index) in mobilelinks">
						<template v-for="(link, subindex) in group">								
									<template v-if="Array.isArray(link)" >
										<template v-if="link.length > 0" >	
											<div class="row no-gutters justify-content-center mobile-links">
											<hr/>
											<div class="col-12 mt-2">
												<a :href="'#nav-' + link[0]['title'].value" class="expand-nav"><h4 class="h4">{{link[0]['title'].value}}</h4></a>
												<div :id="'nav-'+ link[0]['title'].value" class="society-nav-block">	
													<div class="society-nav-inner">
														<ul>
														<template v-for="(subgroup, subsubindex) in link">
															<template v-if="subsubindex < 1">
																<a :href="subgroup['cta'].value"><h3 style="margin-left:0;">{{subgroup['title'].value}}</h3></a>
															</template>
															<template v-else>
																<li><a :href="subgroup['cta'].value">{{subgroup['title'].value}}</a></li>
															</template>
														</template>
														</ul>
														<div class="society-btn swiper-button-prev"></div>
													</div>
													<!--<div class="closeblock-btn swiper-button-prev"></div>-->
												</div>
											</div>
											</div>
												<!--<div :class="link['liclass'] + ' col-1 mobile-hidden'"><a :href="subgroup['cta'].value" >{{subgroup['title'].value}}</a></div>-->
											
										</template>
									</template>
									<template v-else>
										<div :class="'row no-gutters justify-content-center mobile-links ' + link['cssclass'].value" :data-urlexcluderegex="link['urlexcluderegex'].value">
											<hr/>
											<div class="col-12 mt-2">
											<template v-if="link['isgcsignin'] && link['isgcsignin'].value && link['isgcsignin'].value == '1'" >
												
												<a :href="getLoginHref" class="gcsignin" :data-gcsignin="getDictionaryPhrase('GCSignin')" :data-gcsignout="getDictionaryPhrase('GCSignOut')" target="_blank"><h4 class="h4">
												<template v-if="link['mobileimage'] && link['mobileimage'].src !=''">
														<img :src="link['mobileimage'].src" class="menu-icon">
												</template>
												<span class="gcsignintext">{{link['title'].value}}</span></h4></a>
											</template>
											<template v-else>
													<a :href="link['cta'].value"><h4 class="h4">
													<template v-if = "link['mobileimage'] && link['mobileimage'].src !=''">
													<img :src="link['mobileimage'].src" class="menu-icon">
													</template>
													{{link['title'].value}}</h4></a>
											</template>
											</div>
										</div>
									</template>
						</template>
					</template>
					<div class="row no-gutters footer-notes">
						<div class="col-12">
							<div class="container-fluid">
								<div class="row no-gutters">
									<div class="col-12 footer-row">
										<template v-for="(group, index) in mobilebotlinks">
											<template v-for="(link, subindex) in group">
												<template v-if="!Array.isArray(link)" >	
													<a :href="link['cta'].value" target="_blank">{{link['title'].value}}</a>
												</template>
											</template>		
										</template>		
									</div>
								</div>
								<div class="row no-gutters">
									<div class="col-12">
										<p>
										<template v-for="(group, index) in disclaimer">
											<template v-for="(link, subindex) in group">
												<template v-if="!Array.isArray(link)" >	
													{{link['title'].value}}
												</template>
											</template>		
										</template>		
										</p>
									</div>
								</div>
								<div class="row no-gutters mt-2">
									<div class="col-12">
										<a
											href=""
											class="society-nav language-nav d-flex text-white position-relative"
											style="font-size: 1rem"
										>
											<span>Language</span>
											<span class="ml-auto">English</span>
										</a>
										<div class="society-nav-block language-nav-block">
											<div class="society-nav-inner language-selector">
												<ul style="margin-top: 3rem;">
													<li><a class="en-url" href="../en">English</a></li>
													<li><a class="cn-url" href="../cn">简体中文</a></li>
												</ul>
												<div class="society-btn swiper-button-prev"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row no-gutters desktop-hidden">
    		<span class="jenBOpen" id="jenBbooking-nav"></span>
		</div>

	</div>
	
	
     <div id="explore-modal" class="mobile-hidden" style="display:none;">
            <div class="explore-modal">
               <div class="container-fluid pr-5 pl-5 pt-5 pb-5">
                    <div class="row no-gutters"><div class="col-12"><h1>{{getDictionaryPhrase('ChooseHotels')}}</h1></div></div>
					<div class="row no-gutters">
					<template v-if="locations && locations.length > 0">
						 <template v-for="(location, index) in locations">
							<!--<template v-if="location['isdisabled'] && location['isdisabled'].value && location['isdisabled'].value != '1'">-->
							<template v-if="location.children && location.children.length > 0"> 
								<template v-for="(hotelname, subindex) in location['children']">
									<template v-if="!(hotelname['isdisabled'] && hotelname['isdisabled'] == '1')">
									 <div class="col-3">
										<a class="popup-cta" :href="[hotelname['cta'] == ''? '#' : hotelname['cta']]" :data-disabled="hotelname['isdisabled']" :data-propertycode="hotelname && hotelname['hotelcode'] ? hotelname['hotelcode'] : ''" :data-propertycityalias="hotelname && hotelname['cityalias'] ? hotelname['cityalias'] : ''"  :data-propertyhotelalias="hotelname && hotelname['hotelalias'] ? hotelname['hotelalias'] : ''">
										<h3 class="mt-2 property-select" :data-id="hotelname['id']" data-section="events-block" v-html="hotelname['titlehtml']"></h3>
										<p>{{location['title'].value}}</p>
										</a>
									</div>
									</template>												
								</template>												
							</template> 
							<!--</template>--> 
						</template>					
					</template>
					</div>
                    
                </div>
                <img :src="closeBlackIcon" class="close-btn" :data-moduleid="uid"/>
            </div>
        </div>

  </div>
</template>

<script>
import logo from './assets/jen_logo.png';
import navlogo from './assets/navlogo.png';
import {
getDictionaryPhrase,
  searchMoreContentByType,
  graphqlRemoveReserved,
  getLinks,
  getContentByType,
  getObject,
  getObjectById,
  graphqlToObject,
  graphqlFetcherTestSSR,
  graphqlFetcher,
  setCurrencyByGeo
} from './graphqlFetcher.js';
import { uuid } from 'vue-uuid';
import Vue from 'vue';
import Meta from 'vue-meta';
import personicon from './assets/img/header/person.png';
import globeicon from './assets/img/header/globe.png';
import mobileicon from './assets/img/header/mobile.png';
import closeicon from './assets/img/header/close-btn.png';
import closeblackicon from './assets/img/close_btn.png';
import hamburgericon from './assets/img/header/hamburger.png';
import HJBook from './components/HJBook';
import axios from 'axios';
import { getprice, getminprice } from './personalise.js';
import {appendAuthHeaders} from './hjutil.js';


Vue.use(Meta);

export default {
  name: 'Navigation',
  metaInfo() {
    var Adobe_s_account = this.getDictionaryPhrase('Adobe_s_account');
    var Adobe_DevEnvironment = this.getDictionaryPhrase('Adobe_DevEnvironment');
    var Adobe_SiteVersion = this.getDictionaryPhrase('Adobe_SiteVersion');
    var Adobe_HotelBrand = this.getDictionaryPhrase('Adobe_HotelBrand');
    var Adobe_HotelCode = '';
    var Adobe_LoginStatus = 'loggedout';
	var GTMAccountId  = this.getDictionaryPhrase('GTMAccountId');
	var GAAccountId  = this.getDictionaryPhrase('GAAccountId');
	var language = this.$jss.routeData().itemLanguage.substring(this.$jss.routeData().itemLanguage.length-2).toLowerCase();
	if (language.toLowerCase() === "zh" || language.toLowerCase() === "zh-cn")
	{
		language == "cn";
	}
	if (this.$jss.property() != null) {
		this.hotelnames = this.$jss.hotelnames();
		if (this.hotelnames['children'] && this.hotelnames['children'].length > 0)
		{
			for (var i=0; i < this.hotelnames['children'].length; i++)
			{
				if (this.hotelnames['children'][i]['id'].toLowerCase()
										.replace(/-/g, '')
										.replace(/{/g, '')
										.replace(/}/g, '') === this.$jss.property().toLowerCase()
										.replace(/-/g, '')
										.replace(/{/g, '')
										.replace(/}/g, ''))
				{
					if (this.hotelnames['children'][i]["hotelcode"] && this.hotelnames['children'][i]["hotelcode"].value)
						Adobe_HotelCode = this.hotelnames['children'][i]["hotelcode"].value;
					break;
				}
			}
		}
	}
    return {
      script: [
        {
          innerHTML: `
				var s_account = "${Adobe_s_account}";
				var wa = new Object();
				wa.language = "${language}";
				wa.DevEnvironment = "${Adobe_DevEnvironment}";
				wa.SiteVersion = "${Adobe_SiteVersion}";
				wa.HotelBrand = "${Adobe_HotelBrand}";
				wa.HotelCode = "${Adobe_HotelCode}";
				wa.LoginStatus = "${Adobe_LoginStatus}";
                if(window._satellite)window._satellite.track('h5pv');
			  `,
          type: 'text/javascript',
          body: true,
        },
	  {
		src: this.$jss.hjconfig().adobe_analytics_script,
		async: false,
		defer:false,
		type: 'type/javascript',
		body:false,		
	  },
        {
          innerHTML: `
				_satellite.pageBottom();
			  `,
          type: 'text/javascript',
          body: true,
        },
/*		
		,{
			innerHTML: `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer' ? '&l=' + l : ''; j.async = true;j.src =
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTMAccountId}');`,
		type: 'text/javascript',
		body:false,
		},
		{
			src: 'https://www.googletagmanager.com/gtag/js?id=' + this.getDictionaryPhrase('GAAccountId'),
			async: true,
			defer: false,
			type: 'text/javascript',
			body: false,
		},
		{
			innerHTML:`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', '${GAAccountId}');
`,
		type: 'text/javascript',
		body:false,
		}
      ,{
		src: '//api.map.baidu.com/api?v=3.0&' + this.$jss.hjconfig().baidu_map_api_key + '&callback=initBMap', 
		async: false, 
		defer: false,
        type: 'text/javascript',
        body: false,
	  },
      { 
		src: '//maps.googleapis.com/maps/api/js?key=' + this.$jss.hjconfig().google_map_api_key + '&libraries=places&callback=initMap&libraries=geometry', 
		async: true, 
		defer: true,
        type: 'text/javascript',
        body: false,
	  },
      { 
		src: '/dist/hoteljen/js/map.js', 
		async: false, 
		defer: false,
        type: 'text/javascript',
        body: true,
	  }
	  */
      ]
	  /*
	  ,noscript:
	  [
		{
		innerHTML:`
		<iframe src="https://www.googletagmanager.com/ns.html?id=${GTMAccountId}"
		height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
		body: true,
		}
	  ]*/
    };
  },
   components: {
    HJBook,
  },
  data() {
    return {
      contextButtonText: '',
      logoImg: logo,
      navlogoImg: navlogo,
	  personIcon: personicon,
	  globeIcon: globeicon,
	  mobileIcon: mobileicon,
	  closeIcon: closeicon,
	  closeBlackIcon: closeblackicon,
	  hamburgerIcon: hamburgericon,
      links: [],
	  toplinks:[],
	  mobilelinks:[],
	  topurl:[],
	  mobilebotlinks:[],
	  disclaimer:[],
      data_header: [],
      hotelnames: [],
      overrideheight: '',
		homelink: '',
		isHidden: true,
    };
  },
  created() {
   
    this.contextButtonText = this.getDictionaryPhrase('show-context-data');
  },

  inject: {
    toggleContextView: {
      type: Function,
    },
  },
  watch: {
	currency : function(){
		this.$jss.store.setMinpricesobject([]); 		
		this.$jss.store.setLocations(null); 		
		this.getLocations();
	}
  },
  computed: {
	currency: function(){
		return this.$jss.currency();
	},
    getLoginHref() {
        return `${this.$jss.hjconfig() && this.$jss.hjconfig().gcsignin_url}?appid=HJ`;
    }
  },
  mounted() {
    let vm = this;
	
	if (typeof window !== 'undefined') {
		if (window.__JSS_STATE__)
		{
			const ssrRawJson = document.getElementById('__JSS_STATE__');
			if (ssrRawJson) {
				var jss_state = JSON.parse(ssrRawJson.innerHTML);
				const siteLang = jss_state.sitecore.context.language;
				const html = document.querySelector('html');
				html.setAttribute('lang', siteLang );
			}
			
			//var found = document.getElementById('__JSS_STATE__').search("/sitecoreApiKey/g");
			//console.log(found);
			//
		}
	}	


	if (navigator.userAgent.match(/Android/i) ||
		  navigator.userAgent.match(/webOS/i) ||
		  navigator.userAgent.match(/iPhone/i) ||
		  navigator.userAgent.match(/iPad/i) ||
		  navigator.userAgent.match(/iPod/i) ||
		  navigator.userAgent.match(/BlackBerry/i) ||
		  navigator.userAgent.match(/Windows Phone/i)) {
		  vm.$jss.store.setIsmobile(true);
	}
	else
	{
	  vm.$jss.store.setIsmobile(false);
	}

	//console.log(vm.$jss.routeData());
	
    if (vm.$root.hjheader) {
      vm.links = getLinks(vm.$root.hjheader, vm, true, 'mainlinks', vm.$jss.routeData(), vm.$jss.property());
	  vm.toplinks = getLinks(vm.$root.hjheader, vm, true, 'toplinks', vm.$jss.routeData(), vm.$jss.property());
      vm.mobilelinks = getLinks(vm.$root.hjheader, vm, true, 'mobilelinks', vm.$jss.routeData(), vm.$jss.property());
      vm.topurl = getLinks(vm.$root.hjheader, vm, true, 'topURL', vm.$jss.routeData(), vm.$jss.property());
      vm.mobilebotlinks = getLinks(vm.$root.hjheader, vm, true, 'mobilebotlinks', vm.$jss.routeData(), vm.$jss.property());
      vm.disclaimer = getLinks(vm.$root.hjheader, vm, true, 'disclaimer', vm.$jss.routeData(), vm.$jss.property());
	  	
	  for (var i =0; i < vm.toplinks.length; i++){
			if (vm.toplinks[i].length > 1){
				for (var j=0; j< vm.toplinks[i].length; j++){
					if (vm.toplinks[i][j].length >  1){
						for (var k=0; k < vm.toplinks[i][j].length; k++){
							if (vm.toplinks[i][j][k].cta){
								var regexp = /(url=\")[\""A-Za-z0-9.;:!#$%&'*+-\/=?^_`{|}~\p{L}\p{Nd}]{1,}(\")/g;
								var match = vm.toplinks[i][j][k].cta.value.match(regexp);
								if (match != null && match.length > 0)
								{
									vm.toplinks[i][j][k].cta.value = match[0].substring(5, match[0].length - 1);
								}
							}	
						}
					}
					if (vm.toplinks[i][j].cta){
						var regexp = /(url=\")[\""A-Za-z0-9.;:!#$%&'*+-\/=?^_`{|}~\p{L}\p{Nd}]{1,}(\")/g;
						var match = vm.toplinks[i][j].cta.value.match(regexp);
						if (match != null && match.length > 0)
						{
							vm.toplinks[i][j].cta.value = match[0].substring(5, match[0].length - 1);
						}
					}					
				}
			}
	  }

	  
	  for (var i =0; i < vm.topurl.length; i++){
			if (vm.topurl[i].length > 1){
				for (var j=0; j< vm.topurl[i].length; j++){
					if (vm.topurl[i][j].cta){
						var regexp = /(url=\")[\""A-Za-z0-9.;:!#$%&'*+-\/=?^_`{|}~\p{L}\p{Nd}]{1,}(\")/g;
						var match = vm.topurl[i][j].cta.value.match(regexp);
						if (match != null && match.length > 0)
						{
							vm.topurl[i][j].cta.value = match[0].substring(5, match[0].length - 1);
						}
					}					
				}
			}
	  }
	  
	  for (var i =0; i < vm.mobilebotlinks.length; i++){
			if (vm.mobilebotlinks[i].length > 1){
				for (var j=0; j< vm.mobilebotlinks[i].length; j++){
					if (vm.mobilebotlinks[i][j].cta){
						var regexp = /(url=\")[\""A-Za-z0-9.;:!#$%&'*+-\/=?^_`{|}~\p{L}\p{Nd}]{1,}(\")/g;
						var match = vm.mobilebotlinks[i][j].cta.value.match(regexp);
						if (match != null && match.length > 0)
						{
							vm.mobilebotlinks[i][j].cta.value = match[0].substring(5, match[0].length - 1);
						}
					}
				}
			}
	  }
	  
	  
      vm.data_header = getObject(vm.$root.hjheader, vm);
      if (vm.data_header['OverrideHeight']) {
        vm.overrideheight = vm.data_header['OverrideHeight'].value;
      }
    }

    var cookieid = uuid.v1();
    $(document).ready(function() {
      if (getCookie('HJ_ANALYTICS_GLOBAL_COOKIE') == null) {
        setCookie('HJ_ANALYTICS_GLOBAL_COOKIE', cookieid, 365);
        vm.$jss.store.setHJCookie(cookieid);
      } else {
        cookieid = getCookie('HJ_ANALYTICS_GLOBAL_COOKIE');
        vm.$jss.store.setHJCookie(cookieid);
      }

      $.ajax({
        url: '/api/getvisitortype',
        data: 'cookieid=' + cookieid,
        success: function(data) {
          vm.$jss.store.setTravellertype(data);
        },
      });
	  if (getCookie('_gcl_') == null) {
		$('.gcsignin').attr('href', `${vm.$jss.hjconfig().gcsignin_url}?appid=HJ&redirect=${encodeURIComponent(window.location.href)}`);
		$('.gcsignin .gcsignintext').html($('.gcsignin').attr('data-gcsignin'));
	  }
	  else{
		$('.gcsignin').attr('href', `${vm.$jss.hjconfig().gcsignout_url}?appid=HJ&redirect=${encodeURIComponent(window.location.href)}`);
		$('.gcsignin .gcsignintext').html($('.gcsignin').attr('data-gcsignout'));
	  }
		$('.languageswitcher').on('change', function(e){
			e.preventDefault();
			var regex = /(https?\:\/\/)?([\\""A-Za-z0-9.;!#$%&':*\+\-\=?\^_`{|}~]{1,})?\/?(en|cn|jp|zh-cn|zh|ja-jp)?\/?([\/\\""A-Za-z0-9.;!#$%&'*\+\-\=?\^_`{|}~]{1,})?/gmi;
			var match = regex.exec(window.location.href);

			var s = "";
			if (typeof match[1] != 'undefined')
				s += match[1];
			else
				s += "/";
			if (typeof match[2] != 'undefined')
				s += match[2] + "/";
			else
				s += "/";
			s += $('.languageswitcher option:selected').val();
			if (typeof match[4] != 'undefined')
			{
				s += "/"
			}
			if (typeof match[4] != 'undefined')
			{
				s += match[4];
			}
			window.location = s;
		});

		var regex = /(https?\:\/\/)?([\\""A-Za-z0-9.;!#$%&':*\+\-\=?\^_`{|}~]{1,})?\/?(en|cn|jp|zh-cn|zh|ja-jp)?\/?([\/\\""A-Za-z0-9.;!#$%&'*\+\-\=?\^_`{|}~]{1,})?/gmi;
		var match = regex.exec(window.location.href);

		if (typeof match[3] != 'undefined') {
			var s = "";
			if (typeof match[1] != 'undefined')
				s += match[1];
			else
				s += "/";
			if (typeof match[2] != 'undefined')
				s += match[2] + "/";
			else
				s += "/";
			
			var found = false;
			$('.languageswitcher option').each(function(){
				if ($(this).val().toLowerCase() == match[3].toLowerCase())
				{
					$(this).attr('selected','selected');
					found = true;
				}
			});
			if (!found)
				$('.languageswitcher option[value=en]').attr('selected','selected');
			if (typeof match[4] != 'undefined')
			{
				s += "/"
			}
			if (typeof match[4] != 'undefined')
			{
				s += match[4];
			}
		}
		else
		{
			$('.languageswitcher option[value=en]').attr('selected','selected');
		}
    });

	var currencyObject = { "currency": { "AED": "United Arab Emirates dirham", "AFN": "Afghan afghani", "ALL": "Albanian lek", "AMD": "Armenian dram", "ANG": "Netherlands Antillean guilder", "AOA": "Angolan kwanza", "ARS": "Argentine peso", "AUD": "Australian dollar", "AWG": "Aruban florin", "AZN": "Azerbaijani manat", "BAM": "Bosnia and Herzegovina convertible mark", "BBD": "Barbados dollar", "BDT": "Bangladeshi taka", "BGN": "Bulgarian lev", "BHD": "Bahraini dinar", "BIF": "Burundian franc", "BMD": "Bermudian dollar", "BND": "Brunei dollar", "BOB": "Boliviano", "BRL": "Brazilian real", "BSD": "Bahamian dollar", "BTN": "Bhutanese ngultrum", "BWP": "Botswana pula", "BYN": "New Belarusian ruble", "BYR": "Belarusian ruble", "BZD": "Belize dollar", "CAD": "Canadian dollar", "CDF": "Congolese franc", "CHF": "Swiss franc", "CLF": "Unidad de Fomento", "CLP": "Chilean peso", "CNY": "Renminbi|Chinese yuan", "COP": "Colombian peso", "CRC": "Costa Rican colon", "CUC": "Cuban convertible peso", "CUP": "Cuban peso", "CVE": "Cape Verde escudo", "CZK": "Czech koruna", "DJF": "Djiboutian franc", "DKK": "Danish krone", "DOP": "Dominican peso", "DZD": "Algerian dinar", "EGP": "Egyptian pound", "ERN": "Eritrean nakfa", "ETB": "Ethiopian birr", "EUR": "Euro", "FJD": "Fiji dollar", "FKP": "Falkland Islands pound", "GBP": "Pound sterling", "GEL": "Georgian lari", "GHS": "Ghanaian cedi", "GIP": "Gibraltar pound", "GMD": "Gambian dalasi", "GNF": "Guinean franc", "GTQ": "Guatemalan quetzal", "GYD": "Guyanese dollar", "HKD": "Hong Kong dollar", "HNL": "Honduran lempira", "HRK": "Croatian kuna", "HTG": "Haitian gourde", "HUF": "Hungarian forint", "IDR": "Indonesian rupiah", "ILS": "Israeli new shekel", "INR": "Indian rupee", "IQD": "Iraqi dinar", "IRR": "Iranian rial", "ISK": "Icelandic króna", "JMD": "Jamaican dollar", "JOD": "Jordanian dinar", "JPY": "Japanese yen", "KES": "Kenyan shilling", "KGS": "Kyrgyzstani som", "KHR": "Cambodian riel", "KMF": "Comoro franc", "KPW": "North Korean won", "KRW": "South Korean won", "KWD": "Kuwaiti dinar", "KYD": "Cayman Islands dollar", "KZT": "Kazakhstani tenge", "LAK": "Lao kip", "LBP": "Lebanese pound", "LKR": "Sri Lankan rupee", "LRD": "Liberian dollar", "LSL": "Lesotho loti", "LYD": "Libyan dinar", "MAD": "Moroccan dirham", "MDL": "Moldovan leu", "MGA": "Malagasy ariary", "MKD": "Macedonian denar", "MMK": "Myanmar kyat", "MNT": "Mongolian tögrög", "MOP": "Macanese pataca", "MRO": "Mauritanian ouguiya", "MUR": "Mauritian rupee", "MVR": "Maldivian rufiyaa", "MWK": "Malawian kwacha", "MXN": "Mexican peso", "MXV": "Mexican Unidad de Inversion", "MYR": "Malaysian ringgit", "MZN": "Mozambican metical", "NAD": "Namibian dollar", "NGN": "Nigerian naira", "NIO": "Nicaraguan córdoba", "NOK": "Norwegian krone", "NPR": "Nepalese rupee", "NZD": "New Zealand dollar", "OMR": "Omani rial", "PAB": "Panamanian balboa", "PEN": "Peruvian Sol", "PGK": "Papua New Guinean kina", "PHP": "Philippine peso", "PKR": "Pakistani rupee", "PLN": "Polish złoty", "PYG": "Paraguayan guaraní", "QAR": "Qatari riyal", "RON": "Romanian leu", "RSD": "Serbian dinar", "RUB": "Russian ruble", "RWF": "Rwandan franc", "SAR": "Saudi riyal", "SBD": "Solomon Islands dollar", "SCR": "Seychelles rupee", "SDG": "Sudanese pound", "SEK": "Swedish krona", "SGD": "Singapore dollar", "SHP": "Saint Helena pound", "SLL": "Sierra Leonean leone", "SOS": "Somali shilling", "SRD": "Surinamese dollar", "SSP": "South Sudanese pound", "STD": "São Tomé and Príncipe dobra", "SVC": "Salvadoran colón", "SYP": "Syrian pound", "SZL": "Swazi lilangeni", "THB": "Thai baht", "TJS": "Tajikistani somoni", "TMT": "Turkmenistani manat", "TND": "Tunisian dinar", "TOP": "Tongan paʻanga", "TRY": "Turkish lira", "TTD": "Trinidad and Tobago dollar", "TWD": "New Taiwan dollar", "TZS": "Tanzanian shilling", "UAH": "Ukrainian hryvnia", "UGX": "Ugandan shilling", "USD": "United States dollar", "UYI": "Uruguay Peso en Unidades Indexadas", "UYU": "Uruguayan peso", "UZS": "Uzbekistan som", "VEF": "Venezuelan bolívar", "VND": "Vietnamese đồng", "VUV": "Vanuatu vatu", "WST": "Samoan tala", "XAF": "Central African CFA franc", "XCD": "East Caribbean dollar", "XOF": "West African CFA franc", "XPF": "CFP franc", "XXX": "No currency", "YER": "Yemeni rial", "ZAR": "South African rand", "ZMW": "Zambian kwacha", "ZWL": "Zimbabwean dollar" }}

	var cur_currency = localStorage.getItem('curcurrency')
	var currentCurrency = ''

	if(cur_currency && cur_currency != null){
		vm.$jss.store.setCurrency(cur_currency);
	}else {
		vm.$jss.store.setCurrency('USD')
	}

	if (vm.$jss.hjconfig().geolocation_enabled == true)
	{
		if (!(vm.$jss.hjgeocookie() != null && vm.$jss.hjgeocookie() != ''))
		{
			if (getCookie('HJ_GEO_GLOBAL_COOKIE') == null) {
				axios.get('/api/getvisitorgeo').then(result => { 
					setCookie('HJ_GEO_GLOBAL_COOKIE', result.data, 365);
					vm.$jss.store.setHJGeoCookie(result.data);
					if (!localStorage.getItem('curcurrency'))
					{
						setCurrencyByGeo(result.data, vm);
					}
				})
				.then()
				.catch(err => {console.log(err) })
			} else {
				var geolocation = getCookie('HJ_GEO_GLOBAL_COOKIE');
				vm.$jss.store.setHJGeoCookie(geolocation);
				if (!localStorage.getItem('curcurrency'))
				{
					setCurrencyByGeo(geolocation, vm);
				}
			}
		}
	}
	else
	{
		vm.$jss.store.setHJGeoCookie("US");
	}

	
	currentCurrency = vm.togglegeolocation();
	
	// setting currency on navigation dropdown
	$(document).ready(function() {
		if(localStorage.getItem('curcurrency') && localStorage.getItem('curcurrency') != null) 
			currentCurrency = localStorage.getItem('curcurrency')
		else 
			currentCurrency = "USD"
		console.log(`current currency document ready \n${currentCurrency}`)
		var elemCon = document.querySelectorAll('[data-value="'+ currentCurrency +'"]')[0];
		if (document.getElementById('currencyDropdown'))
		{
			document.getElementById('currencyDropdown').innerHTML = currentCurrency;
			$(elemCon).find('.currency-checkbox').attr('checked','checked')
			$(elemCon).addClass('active')
		}
	})

	vm.hotelnames = vm.$jss.hotelnames();
	var _minprices = [];
	if (!(vm.$jss.minpricesobject() != null && vm.$jss.minpricesobject().length > 0))
	{
		vm.$jss.store.setMinpricesobject(getminprice(null, vm.$jss.prices(), vm.$jss.currency(), vm.$jss.travellertype(), vm.$jss.hotels()['children']));
	}
	_minprices = vm.$jss.minpricesobject();
	if (vm.$jss.locations() != null && vm.$jss.locations().length > 0)
	{
		vm.locations = vm.$jss.locations();
	}
	else
	{
		
      var _locations = getContentByType(
        vm.$jss.constants(),
        'hjlocation',
        vm,
        false,
        false,
        'other',
        false
      );
	  
    if (vm.hotelnames && vm.hotelnames.children && vm.hotelnames.children.length > 0 && _locations) {
      for (var i = 0; i < _locations.length; i++) {
        var hotel_count = 0;
        _locations[i]['children'] = [];
        for (var j = 0; j < vm.hotelnames['children'].length; j++) {
          if (
            vm.hotelnames['children'][j]['location'] &&
            vm.hotelnames['children'][j]['location'].value
          ) {
            if (
              vm.hotelnames['children'][j]['location'].value
                .toLowerCase()
                .replace(/-/g, '')
                .replace(/{/g, '')
                .replace(/}/g, '') ===
              _locations[i].id
                .toLowerCase()
                .replace(/-/g, '')
                .replace(/{/g, '')
                .replace(/}/g, '')
            ) {
				var _price = _minprices.find(x => x.hotelcode.toLowerCase().trim() === vm.hotelnames['children'][j]['hotelcode'].value.toLowerCase().trim());
              _locations[i]['children'].push({
                title: vm.hotelnames['children'][j]['title'].value,
                titlehtml: vm.hotelnames['children'][j]['titlehtml'].value,
                id: vm.hotelnames['children'][j]['id'],
				cityalias: vm.hotelnames['children'][j]['cityalias'].value,
				hotelalias: vm.hotelnames['children'][j]['hotelalias'].value,
				hotelcode: vm.hotelnames['children'][j]['hotelcode'].value,
                cta: vm.hotelnames['children'][j]['cta'].value,
                isdisabled: vm.hotelnames['children'][j]['isdisabled'].value,
                adobebuttonname: vm.hotelnames['children'][j]['adobebuttonname'],
                adobelocationid: vm.hotelnames['children'][j]['adobelocationid'],
                adobepreviousbuttonclick:
                  vm.hotelnames['children'][j]['adobepreviousbuttonclick'],
				hotelalias: vm.hotelnames['children'][j]['hotelalias'].value,
				hotelcode: vm.hotelnames['children'][j]['hotelcode'].value,
				cityalias: vm.hotelnames['children'][j]['cityalias'].value,
				price: _price != undefined && _price != null ? _price.price : 0
              });
            }
          }
        }
      }
	  vm.$jss.store.setLocations(_locations);
	  vm.locations = vm.$jss.locations();
    }
	}

   /* $('.navlogo')
      .unbind('click')
      .bind('click', function() {
        //console.log('Nav Click');
        var mobileNav = $('.mobile-nav .HJNav');
        var tl = new TimelineMax({ delay: 0, repeat: 0 });
        tl.to(mobileNav, 2.5, { x: '0%', y: '0%', ease: Expo.easeOut });
      });

    $('.navClose')
      .unbind('click')
      .bind('click', function() {
        //console.log('Nav Click');
        var mobileNav = $('.mobile-nav .HJNav');
        var tl = new TimelineMax({ delay: 0, repeat: 0 });
        tl.to(mobileNav, 2.5, { x: '0%', y: '-100%', ease: Expo.easeOut });
      });
	*/
	
	//Header JS
	var showCta = false;
	var notHomePage = false;
	var newString = window.location.pathname.split("/")
	var canvasHeight = (window.outerHeight * .70);

	for(var y=0;y<newString.length;y++){
		switch(newString[y]){
			case 'host': {
				notHomePage = true;
				break;
			}
			case 'deals': {
				notHomePage = true;
				break;
			}
			case 'society': {
				notHomePage = true;
				break;
			}
			case 'jensociety': {
				notHomePage = true;
				break;
			}
			case 'our-story': {
				notHomePage = true;
				break;
			}
		}
	}
	
	if(window.outerWidth > parseInt(1024)){

		if(!notHomePage){
			var prevScrollpos = window.pageYOffset;
			window.onscroll = function() {
				var currentScrollPos = window.pageYOffset;

				if(window.pageYOffset > canvasHeight && showCta === false){
					//console.log(document.querySelectorAll(".btn-jump"));
					//console.log(document.querySelectorAll(".book-nav-cta"));
					document.querySelectorAll(".btn-jump")[0].style.setProperty("display","block");
					document.querySelectorAll('.book-nav-cta')[0].classList.add('active')
					var space = document.querySelectorAll(".space-hr")
					for(var x=0;x<space.length;x++) space[x].classList.remove('active')
					setTimeout(function(){
						document.querySelectorAll(".btn-jump")[0].style.setProperty("opacity","1");
					},200)
					showCta = true
				}

				if(window.pageYOffset < canvasHeight && showCta === true){
					//console.log(document.querySelectorAll(".btn-jump"));
					//console.log(document.querySelectorAll(".book-nav-cta"));
					document.querySelectorAll(".btn-jump")[0].style.setProperty("display","block");
					document.querySelectorAll('.book-nav-cta')[0].classList.remove('active')
					setTimeout(function(){
						document.querySelectorAll(".btn-jump")[0].style.setProperty("opacity","1");
						var space = document.querySelectorAll(".space-hr")
						for(var x=0;x<space.length;x++) space[x].classList.add('active')
					},200)
					setTimeout(function(){
						document.querySelectorAll(".btn-jump")[0].style.setProperty("opacity","0");
					},200);
					setTimeout(function(){
						document.querySelectorAll(".btn-jump")[0].style.setProperty("display","none");
					},700)

					if(document.querySelectorAll('.booking-nav')[0].classList.contains('active')){
						document.querySelectorAll('.booking-nav')[0].style.setProperty('overflow','hidden')
						setTimeout(function(){document.querySelectorAll('.booking-nav')[0].classList.remove('active')},50)
					}
					showCta = false
				}
				prevScrollpos = currentScrollPos;
			}
		}
		else{
			//console.log(document.querySelectorAll(".btn-jump"));
			//console.log(document.querySelectorAll(".book-nav-cta"));
			// var space = document.querySelectorAll(".space-hr")
			setTimeout(function(){
			// for(var x=0;x<space.length;x++) 
			if(document.querySelectorAll(".btn-jump")[0]){
				// space[x].classList.remove('active')
				document.querySelectorAll(".btn-jump")[0].style.setProperty("display","block");
				document.querySelectorAll('.book-nav-cta')[0].classList.add('active')
				document.querySelectorAll(".btn-jump")[0].style.setProperty("opacity","1");
			}
			},200)
		}
	}

		
		$('.hjnavigation').on('click', 'a.language-nav', function(e){
			//console.log('clicked');
			e.preventDefault();
			$(this).next().addClass('active')
		});
		
		$('.hjnavigation').on('click', '.js-header-mobile', function(e) {
			e.preventDefault();
			$(this).next('.app-layer').toggle();
		});

		/*$('a.selected-destination').click(function(e){
			e.preventDefault();
			e.stopPropagation();
			$(this).parent().parent().parent().find('.destination-nav-block').addClass('active')
		});
		
		$('.hjnavigation').on('click', 'div.destination-btn', function(e){
			e.preventDefault();
			$(this).parent().removeClass('active')
		});*/
	  $('.hjnavigation').on('click', '.menu-destination-anchor', function(e){
			e.preventDefault();
			if ($(this).next('#menu-destination').hasClass('collapse'))
			{
				$(this).next('#menu-destination').removeClass('collapse');
				$(this).next('#menu-destination').addClass('expand');
			}
			else if ($(this).next('#menu-destination').hasClass('expand'))
			{
				$(this).next('#menu-destination').removeClass('expand');
				$(this).next('#menu-destination').addClass('collapse');
			}
		});


		// document.querySelectorAll('.mobile-close-btn')[0].addEventListener('click',closeNavigation ,false);
		// document.getElementById('btn-hamburger').addEventListener('click', toggleMenu, false);
		
		// function toggleMenu(e){
		// 	e.preventDefault()
		// 	document.querySelectorAll('.mobileMenu')[0].style.setProperty('top','0');
		// }
		// function closeNavigation(e){
		// 	e.preventDefault();
		// 	document.querySelectorAll('.mobileMenu')[0].style.setProperty('top','-100vh');
		// }

  },
  updated: function(){
      let vm = this;
	  
	  	var propertyid = vm.$jss.property();
	var hotelDetails = {longitude:{value: 0}, latitude:{value:0}, Title:{value:'HotelJen Hong Kong'}};
	if (propertyid && propertyid != null){
		$('.footer-container-property').removeClass('hidden');
		propertyid = propertyid.replace(/\-/g,"").toUpperCase();
		hotelDetails = getObject(getObjectById(vm.$jss.hotels(),propertyid), vm);
		vm.homelink = hotelDetails.cta.value;
		var locations = vm.getLocations();
		for(var i=0; i < locations.length; i++)
		{
			if (locations[i]['id'].toUpperCase().replace(/-/g, '')
									.replace(/{/g, '')
									.replace(/}/g, '') === hotelDetails.location.value.toUpperCase().replace(/-/g, '')
									.replace(/{/g, '')
									.replace(/}/g, ''))
			{
				$('.header-property-m').html(locations[i]['title'].value);
				break;
			}
		}
		//$('.header-property-m').html(hotelDetails.cityalias.value);
		}else{
				vm.homelink = './hotels/jen/';
		}
		vm.homelink = './hotels/jen/';
		
		var language = vm.$jss.routeData().itemLanguage.substring(vm.$jss.routeData().itemLanguage.length-2).toLowerCase();
		if (language.toLowerCase() === "zh" || language.toLowerCase() === "zh-cn")
		{
			vm.homelink = '/cn/hotels/jen';
		}
		else
		{
			vm.homelink = '/' + language + '/hotels/jen';
		}
		
		// $('.currencyselect').off().on('click', function (e) {

		// 	var optionSelected = $(this).find("option:selected");
		// 	var valueSelected = optionSelected.val();
		// 	vm.$jss.store.setCurrency(valueSelected);
		// });  
		$('.hjnavigation').on('click', '.dropdown-item', function (e) {

			var optionSelected = $(this).attr('data-value');
			var checkList = document.querySelectorAll('.currency-checkbox')
			var currrencyList = document.querySelectorAll('.dropdown-item')
			for(var v=0;v<checkList.length;v++) checkList[v].removeAttribute('checked')
			for(var v=0;v<checkList.length;v++) currrencyList[v].classList.remove('active')
			$(this).find('.currency-checkbox').attr('checked','checked');
			$(this).addClass('active')
			// var valueSelected = optionSelected.val();
			$('#currencyDropdown').text(optionSelected)
			localStorage.setItem('curcurrency',optionSelected)
			vm.$jss.store.setCurrency(optionSelected);
			setTimeout(function(){$('#galleryTab0').click()},3000)
		});  

		$('.mobile-close-btn').click(function(e){
			e.preventDefault();
			$(this).closest('.mobileMenu').css('top','-110vh')
		});

		$('#btn-hamburger').click(function(e){
			e.preventDefault();
			$(this).closest('.header-container').find('.mobileMenu').css('top','0')
		});
	  
	  $('.hjnavigation').on('click', 'a.expand-nav', function(e){
			e.preventDefault();
			var targetblock = $(this).attr('href');
			$(targetblock).addClass('active');
		});
		
	/*
	  $('.hjnavigation').on('click', '.menu-destination-anchor', function(e){
			e.preventDefault();
			if ($(this).next('#menu-destination').hasClass('collapse'))
			{
				$(this).next('#menu-destination').removeClass('collapse');
				$(this).next('#menu-destination').addClass('expand');
			}
			else if ($(this).next('#menu-destination').hasClass('expand'))
			{
				$(this).next('#menu-destination').removeClass('expand');
				$(this).next('#menu-destination').addClass('collapse');
			}
		});
	*/
	
		$('div.closeblock-btn').click(function(e){
			e.preventDefault();
			$(this).parent().parent().parent().removeClass('active');
		});
		$('div.society-btn').click(function(e){
			e.preventDefault();
			$(this).closest('.society-nav-block').removeClass('active')
		});
	  
	//   $('a.selected-destination').click(function(e){
			// e.preventDefault();
			// e.stopPropagation();
			// var targetblock = $(this).attr('href');;
			// console.log(targetblock);
			// $(targetblock).addClass('active');
			//$(this).parent().parent().parent().find('.destination-nav-block').addClass('active')
		// });
		
		$('.hjnavigation').on('click', 'a.selected-destination', function(e){
			e.preventDefault();
			e.stopPropagation();
			$(this).next().addClass('active')
		});
		$('a.submenu-close-btn-header').click(function(e){
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('.property-submenu').removeClass('active')
		});
		
		$('.hjnavigation').on('click', 'div.destination-btn', function(e){
			e.preventDefault();
			$(this).parent().removeClass('active')
		});


		$('.jenBClose').unbind('click').click(function() {
			if (window.innerWidth < 1025) {
				setTimeout(function(){
				$('#jenBbooking-nav').css('display', 'block');
				},300)
				$('.booking-nav').removeClass('loaded');
				document.body.style.setProperty("position","relative")
				const scrollY = document.body.style.top;
				document.body.style.position = '';
				document.body.style.top = '';
				window.scrollTo(0, parseInt(scrollY || '0') * -1);
			}
		});

		$('#jenBbooking-nav').unbind('click').bind('click',function() {
			if(window.innerWidth < 1025){
				document.body.style.setProperty("top",`-${window.scrollY}px`)
				document.body.style.setProperty("position","fixed")
				$('.booking-nav').addClass('loaded');
				setTimeout(function(){$('#jenBookingDetails').css("display","block")},300)
				$('#jenBbooking-nav').css("display","none");
			}
		});
		
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");

		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
		{
			console.log('IE');
			$('html').addClass('isIE');
		}
		else  // If another browser, return 0
		{
			console.log('other browser');
		}
		
		if (vm.$jss.property() && vm.$jss.property() != ''){
	
			document.getElementById('other-hotels').addEventListener('click',showHotels,false);
			document.querySelectorAll('.close-btn')[0].addEventListener('click',closeModal,false);
			function showHotels(e){
				e.preventDefault();
				
				document.getElementById('explore-modal').style.setProperty('opacity','1')
				document.getElementById('explore-modal').style.setProperty('display','block')			
				document.getElementById('explore-modal').style.setProperty('z-index','13')
			}
			function closeModal(e){
				e.preventDefault();
				document.getElementById('explore-modal').style.setProperty('opacity','0')
				document.getElementById('explore-modal').style.setProperty('display','none')
				setTimeout(function(){document.getElementById('explore-modal').style.setProperty('z-index','-1')},500);
			}
		
		}
		
		//for Anchor links
		$('.anchorlink').unbind('click').bind('click', function(e){
			console.log("anchor");
			e.preventDefault($(this).attr('data-anchorlink'));
			var anchoralias = $(this).attr('data-anchorlink');
			if (anchoralias && anchoralias != ''){
				$('html, body').animate({
					scrollTop: $('#'+anchoralias).offset().top - 100
				}, 800, function(){

					//window.location.hash = anchoralias;
					});
			}
			
		});
		
		//Booking bar 
		$('.booking-nav-cta').unbind('click').bind('click',showBookingNav);
		
	/*	    e.preventDefault();
    if(document.querySelectorAll('.booking-nav')[0].classList.contains('active')){
        document.querySelectorAll('.booking-nav')[0].style.setProperty('overflow','hidden')
        setTimeout(function(){document.querySelectorAll('.booking-nav')[0].classList.remove('active')},50)
    }
    else{
        document.querySelectorAll('.booking-nav')[0].classList.add('active')
        setTimeout(function(){document.querySelectorAll('.booking-nav')[0].style.setProperty('overflow','visible')},300)
    }*/

		$(document).ready(function() {
			$('.hj-logo').parent('a').on('click', function(e){
				e.preventDefault();
				var url = ""
				window.location = vm.homelink;
				//window.location = "http://localhost:3000/hotels/jen";
			});
			$('.hj-logo-link').parent('a').on('click', function(e){
				e.preventDefault();
				//console.log(vm.homelink);
				window.location = vm.homelink;
				//windows.location = "http://localhost:3000/hotels/jen";
			});
			var language = vm.$jss.routeData().itemLanguage.substring(vm.$jss.routeData().itemLanguage.length-2).toLowerCase();
			if (language.toLowerCase() === "zh" || language.toLowerCase() === "zh-cn")
			{
				language == "cn";
				// var image = $('#jenBbooking-nav').css('background-image');
				// image = image.replace(/bookNow.png/g, "bookNow-zh.png")
				// $('#jenBbooking-nav').css('background-image', image);
				$('#jenBbooking-nav').css('background-image',`url(${window.location.origin}/dist/hoteljen/img/bookNow-zh.png)`);	
				console.log(`${window.location.origin}/dist/hoteljen/img/bookNow-zh.png`)
				$('.language-nav span:first').html('语言');	
				$('.language-nav span:eq(1)').html('简体中文');
			}
			else
			{
				// var image = $('#jenBbooking-nav').css('background-image');
				// image = image.replace(/bookNow-zh.png/g, "bookNow.png")
				// $('#jenBbooking-nav').css('background-image', image);
				$('#jenBbooking-nav').css('background-image',`url(${window.location.origin}/dist/hoteljen/img/bookNow.png)`);									
				$('.language-nav span:first').html('Language');	
				$('.language-nav span:eq(1)').html('English');
			}
			// comment
			//$('.language-nav').next().find('.en-url').attr('href', ('/en/' + window.location.pathname.replace('/cn/', '/en/').replace('/en/', '')).replace(/\/\//g,"/"));
			//$('.language-nav').next().find('.cn-url').attr('href', ('/cn/' + window.location.pathname.replace('/en/', '').replace('/cn/', '')).replace(/\/\//g,"/"));
			
			var enUrl = '/en/' + window.location.pathname.replace('/cn/', '/en/').replace('/en/', '');
			var cnUrl = '/cn/' + window.location.pathname.replace('/en/', '').replace('/cn/', '');
			$('.language-nav').next().find('.en-url').attr('href', enUrl.replace(/\/\//g,"/"));
			$('.language-nav').next().find('.cn-url').attr('href', cnUrl.replace(/\/\//g,"/"));
			console.log(enUrl);
			console.log(cnUrl);
			console.log($('.language-nav').next().find('.en-url').attr('href'));
			console.log($('.language-nav').next().find('.cn-url').attr('href'));
			
			$('.hjnavigation').on('click', 'a.language-nav', function(e){
				//console.log('clicked');
				e.preventDefault();
				$(this).next().addClass('active')
			});
			
		});

		// window.addEventListener('load',function(){
			if(window.innerWidth > 1024){
				// document.getElementById('currencyDropdown').addEventListener('click',function(event){
					$('#currencyDropdown').unbind('click').bind('click',function(event){
					event.stopPropagation();
					if($('#currencyDropdown').parent().hasClass('show')){
						$('#currencyDropdown').parent().removeClass('show')
						$('.dropdown-menu').removeClass('show')
					}else{
						$('#currencyDropdown').parent().addClass('show')
						$('.dropdown-menu').addClass('show')
					}
				// },false)
				})
				// document.body.addEventListener('click',function(event){
				$('body').unbind('click').bind('click',function(event){
					event.stopPropagation();
					if($('#currencyDropdown').parent().hasClass('show')){
						$('#currencyDropdown').parent().removeClass('show')
						$('.dropdown-menu').removeClass('show')
					}
				// },false)
				})
			}
		// })
		
  },
  methods: {
	getLocations: function()
	{
		var hotels = null;
		if (!(this.$jss.minpricesobject() != null && this.$jss.minpricesobject().length > 0))
		{
			if (!(this.$jss.hotels() == null || (this.$jss.hotels() != null && this.$jss.hotels().length == 0)))
			{
				this.$jss.store.setMinpricesobject(getminprice(null, this.$jss.prices(), this.$jss.currency(), this.$jss.travellertype(), this.$jss.hotels()));
			}
		}
		if (this.$jss.locations() != null && this.$jss.locations().length > 0)
		{
			this.locations = this.$jss.locations();
		}
		else
		{
			var _locations = getContentByType(
				this.$jss.constants(),
				'hjlocation',
				this,
				false,
				false,
				'other',
				false
			  );	  
			if (this.hotelnames && this.hotelnames.children && this.hotelnames.children.length > 0 && _locations) {
				for (var i = 0; i < _locations.length; i++) {
					var hotel_count = 0;
					_locations[i]['children'] = [];
					for (var j = 0; j < this.hotelnames['children'].length; j++) {
						if (
							this.hotelnames['children'][j]['location'] &&
							this.hotelnames['children'][j]['location'].value
							) {
							if (
							  this.hotelnames['children'][j]['location'].value
								.toLowerCase()
								.replace(/-/g, '')
								.replace(/{/g, '')
								.replace(/}/g, '') ===
							  _locations[i].id
								.toLowerCase()
								.replace(/-/g, '')
								.replace(/{/g, '')
								.replace(/}/g, '')
							) {
								var _price = this.$jss.minpricesobject().find(x => x.hotelcode.toLowerCase().trim() == this.hotelnames['children'][j]['hotelcode'].value.toLowerCase().trim());
							  _locations[i]['children'].push({
								title: this.hotelnames['children'][j]['title'].value,
								titlehtml: this.hotelnames['children'][j]['titlehtml'].value,
								id: this.hotelnames['children'][j]['id'],
								cityalias: this.hotelnames['children'][j]['cityalias'].value,
								hotelalias: this.hotelnames['children'][j]['hotelalias'].value,
								hotelcode: this.hotelnames['children'][j]['hotelcode'].value,
								cta: this.hotelnames['children'][j]['cta'].value,
								isdisabled: this.hotelnames['children'][j]['isdisabled'].value,
								adobebuttonname: this.hotelnames['children'][j]['adobebuttonname'],
								adobelocationid: this.hotelnames['children'][j]['adobelocationid'],
								adobepreviousbuttonclick:
								  this.hotelnames['children'][j]['adobepreviousbuttonclick'],
								price: _price != undefined && _price != null ? _price.price : 0
							  });
							}
						}
					}
				}
				this.$jss.store.setLocations(_locations);
				this.locations = this.$jss.locations();
			}
		}
		return this.$jss.locations();
	},
	getDictionaryPhrase: function(key)
	{
		return getDictionaryPhrase(key, this);
	},
    toggleContext() {
      this.toggleContextView();
      this.contextButtonText =
        this.contextButtonText === this.getDictionaryPhrase('hide-context-data')
          ? this.$t('show-context-data')
          : this.$t('hide-context-data');
    },
	togglegeolocation(currentCurrency) {
		if (this.$jss.hjgeocookie() != null && this.$jss.hjgeocookie() != '')
		{
			var countries = getContentByType(this.$jss.constants(), "hjcountry", this, false, false, 'other', false);
			var currencies = getContentByType(this.$jss.constants(), "hjcurrency", this, false, false, 'other', false);
			
			if (countries ? countries.length > 0 : false)
			{
				for (var i=0; i < countries.length; i++)
				{
					if (countries[i].countrycode.value.toLowerCase() === this.$jss.hjgeocookie().toLowerCase())
					{
						if (currencies.length > 0)
						{
							for (var j=0; j < currencies.length; j++)
							{
								if (currencies[j].id.toLowerCase().replace(/-/g, "").replace(/{/g, "").replace(/}/g, "").trim() === countries[i].currency.value.toLowerCase().replace(/-/g, "").replace(/{/g, "").replace(/}/g, "").trim())
								{
									//console.log(localStorage.getItem('curcurrency'));
									if(localStorage.getItem('curcurrency') && localStorage.getItem('curcurrency') != null){
										this.$jss.store.setCurrency(localStorage.getItem('curcurrency'))
										currentCurrency = localStorage.getItem('curcurrency')
									} 
									else {
										currentCurrency = currencies[j].code.value;
										localStorage.setItem('curcurrency',currencies[j].code.value);
										//cur_currency = currencies[j].code.value;
										this.$jss.store.setCurrency(currencies[j].code.value);
									}

									break;
								}
							}
						}
					}
				}
			}
		}
		return currentCurrency;
	}
  },
};
</script>
